import apiClient from "@services/api/apiClient.jsx";

const branchApi = {
    // 지점 정보 가져오기
    getBranches: async () => {
        try {
            const response = await apiClient.get("/infra/branches");
            
            // 다양한 응답 구조 처리
            const branches = response.data?.data?.content || 
                           response.data?.content || 
                           response.data || 
                           [];
            
            return branches;
        } catch (error) {
            console.error("Failed to fetch branches:", error);
            throw error;
        }
    },
};

export default branchApi;